import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          {aboutData.title}
        </h2>
        <div className="bg-background-100 border border-background-200/70 rounded-lg p-6 md:p-8 space-y-4">
          {aboutData.paragraphs.map((paragraph, idx) => (
            <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}